import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { AgendaDto, AgendaServiceProxy, AnexoConsultaDto, ConsultaServiceProxy, ConvenioDto, ConvenioServiceProxy, DiaLivreDto, EventoServiceProxy, HorarioLivreDto, StatusConsultaEnum, TipoConsultaEnum, TipoUsuarioEnum, UpdateConsultaDto } from '@shared/service-proxies/service-proxies';
import { TipoConsultaList } from '@shared/model/tipo-consulta-enum.model';
import * as moment from 'moment';
import { StringUtils } from '@shared/helpers/StringUtils';
import { finalize } from 'rxjs/operators';
import { TipoArquivoProntuarioList } from '@shared/model/tipo-arquivo-prontuario-enum.model';
import { DataService } from '@shared/services/data.service';
import { CustomDatepickerSelectedComponent } from '@shared/components/custom-datepicker-selected/custom-datepicker-selected.component';

@Component({
  selector: 'app-edit-consulta',
  templateUrl: './edit-consulta.component.html',
  styleUrls: ['./edit-consulta.component.scss']
})
export class EditConsultaComponent extends AppComponentBase implements OnInit {
  public tipoConsulta: TipoConsultaList = new TipoConsultaList();
  public saving: boolean = false;
  public convenios: ConvenioDto[] = [];
  public horaConsulta: string;
  public dataConsulta: string;
  public dataAtual: string = moment().format("YYYY-MM-DD");
  public newAnexo: AnexoConsultaDto = new AnexoConsultaDto();
  public tipoArquivo: TipoArquivoProntuarioList = new TipoArquivoProntuarioList();
  public diasDisponiveis: string[] = [];
  public horariosDisponiveis: HorarioLivreDto[] = [];
  protected agendas: AgendaDto[] = [];
  protected horarioSelecionado: HorarioLivreDto = new HorarioLivreDto();
  protected editDados: boolean = true;
  private datasDisponivies: DiaLivreDto[] = [];
  private availableDates: Date[];
  private agendaInicial: string;
  private horarioInicial: string;

  @ViewChild('file') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('datePicker') datePickerInput!: CustomDatepickerSelectedComponent;

  @Input() consulta: UpdateConsultaDto = new UpdateConsultaDto();
  @Input() tipoUsuario: TipoUsuarioEnum;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    public bsModalRef: BsModalRef,
    private readonly _consultaService: ConsultaServiceProxy,
    private readonly _convenioService: ConvenioServiceProxy,
    private readonly _eventoService: EventoServiceProxy,
    private readonly _dataService: DataService,
    private readonly _agendaService: AgendaServiceProxy,
  ) { super(injector) }

  ngOnInit(): void {
    this.getConvenios();
    this.getAgenda();
    this.agendaInicial = this.consulta.agendaId;
    this.horaConsulta = this.consulta.dataConsulta.format("HH:mm");
    this.horarioInicial = this.consulta.dataConsulta.format("HH:mm");
    this.dataConsulta = this.consulta.dataConsulta.format('DD/MM/YYYY');
    this.editDados = this.consulta.statusConsulta != StatusConsultaEnum._3
    this.consulta.novosAnexos = [];
    this.consulta.anexosRemovidos = [];
    this.getDatasDisponiveis(moment(this.consulta.dataConsulta).startOf('month'), moment(this.consulta.dataConsulta).endOf('month'), true);
  }

  protected save(): void {
    this.saving = true;
    this.consulta.dataConsulta = this._dataService.combinarDataHora(this.dataConsulta, this.horaConsulta);
    if (!this.isFormValided()) {
      this.saving = false;
      return;
    }
    abp.ui.setBusy();
    this.consulta.anexos = [];
    this._consultaService.update(this.consulta).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.bsModalRef.hide();
    });
  }

  protected addFile(files: AnexoConsultaDto[]): void {
    this.consulta.novosAnexos = [...files];
  }

  protected removeFile(files: AnexoConsultaDto[]): void {
    this.consulta.anexosRemovidos = [...files];
  }

  private isFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.consulta.descricao), message: "Informe a descrição da consulta." },
      { condition: StringUtils.isNullOrEmpty(this.dataConsulta), message: "Informe a data da consulta." },
      { condition: StringUtils.isNullOrEmpty(this.horaConsulta), message: "Informe o horário da consulta." },
      { condition: StringUtils.isNullOrEmpty(this.consulta.tipoConsulta), message: "Informe o tipo da consulta." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

  protected getHorariosDisponiveis(): void {
    var agendaAtiva = this.agendas.find(x => x.id == this.agendaInicial);
    this.horariosDisponiveis = [];
    this.horarioSelecionado = new HorarioLivreDto();
    this.horariosDisponiveis = [...this.datasDisponivies.find(x => x.data.format("DD/MM/YYYY") == this.dataConsulta).horarios];
    if (!this.horariosDisponiveis.some(x => x.horaInicio == this.horarioInicial) && this.agendaInicial == this.consulta.agendaId) {
      var diaConsulta = this._dataService.combinarDataHora(this.dataConsulta, this.horarioInicial);
      let horario = new HorarioLivreDto();
      horario.agendaId = this.consulta.agendaId;
      horario.data = this.consulta.dataConsulta;
      horario.horaInicio = diaConsulta.format("HH:mm");
      horario.horaFim = diaConsulta.add(agendaAtiva?.duracaoConsulta ?? 30, 'minute').format("HH:mm");
      this.horarioSelecionado = horario;
      this.horariosDisponiveis.push(horario);
      this.horariosDisponiveis.sort((x, y) => {
        if (x.horaInicio < y.horaInicio) return -1;
        if (x.horaInicio > y.horaInicio) return 1;
        return 0;
      });
      this.horaConsulta = this.horarioSelecionado.horaInicio
    }
  }

  protected setHorario(): void {
    this.horaConsulta = this.horarioSelecionado.horaInicio;
  }

  protected setDataConsulta(data: string): void {
    this.horariosDisponiveis = [];
    this.dataConsulta = moment(data).format("DD/MM/YYYY");
    this.getHorariosDisponiveis();
  }

  protected atualizarDatasDisponiveis(datas: moment.Moment[]): void {
    if (datas)
      this.getDatasDisponiveis(datas[0], datas[1]);
  }

  protected selecionarAgenda(): void {
    if (this.consulta.agendaId) {
      this.getDatasDisponiveis(moment().startOf('month'), moment().endOf('month'));
      this.datePickerInput.dataConsulta = null;
      this.horarioSelecionado = null;
      this.horariosDisponiveis = [];
      this.diasDisponiveis = [];
    }
  }

  protected getAgenda(): void {
    abp.ui.setBusy();
    this._agendaService.getAgendaProfissional(this.consulta.profissionalId, this.appSession.clinicaId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.agendas = result;
    });
  }

  private getDatasDisponiveis(dataInicio: moment.Moment, dataFim: moment.Moment, getHorario: boolean = false): void {
    abp.ui.setBusy();
    this._eventoService.getHorariosDisponiveisPorDia(this.consulta.profissionalId, this.appSession.clinicaId, dataInicio, dataFim, this.consulta.agendaId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.datasDisponivies = result;
      const mapa = new Map<string, moment.Moment>();

      for (const item of result) {
        const dataChave = item.data.format('YYYY-MM-DD');
        if (!mapa.has(dataChave)) {
          mapa.set(dataChave, item.data);
        }
      }
      let datas = Array.from(mapa.values()).map(m => m.format('DD/MM/YYYY'))
      this.availableDates = datas.map(dateStr => {
        const [day, month, year] = dateStr.split('/').map(Number);
        return new Date(year, month - 1, day);
      });
      this.datePickerInput.updateDatas(this.availableDates);
      if (getHorario)
        this.getHorariosDisponiveis();
    });
  }

  protected getConvenios(): void {
    abp.ui.setBusy();
    this._convenioService.getConvenios().pipe(
      finalize(() => {
        abp.ui.clearBusy()
      })
    ).subscribe((result) => {
      this.convenios = result;
    })
  }
}
